import React, {useState, useEffect} from "react";
import {ViewAcademy, ThinTitle, TextAca} from "./AcademyStyles";
import {Content} from "../../../styles/GlobalStyles";
import Color from "../../../assets/Colors";
import {CardWhiteCoach, CardCoach} from "../../course_details/components/FacilitadorStyle";
import {ContentContainer} from "../../../styles/Products";

export default function Bienvenida() {

   const [isMobile, setMobile] = useState(true);
   useEffect(() => {
      setMobile(window.screen.width < 500);
   }, []);
   if (isMobile) {
      return (
         <ViewAcademy>
            <Content>
               <ContentContainer>
                  <CardCoach width="100%" className="full">
                     <img src={require("../../../assets/image/views/mapa_mobile.png")} alt="experience" className="profileImg" />
                     <CardWhiteCoach className="hasIcon contact">
                        <img src={require("../../../assets/icons/location.png")} alt="experience" className="iconDot" width="100%" />
                        <ThinTitle color={Color.primary}>NUESTRA UBICACIÓN</ThinTitle>
                        <TextAca>
                        Domecq Academy se encuentra ubicado dentro del Corporativo Casa Pedro Domecq, en el corazón
                           de Polanco.<br /> <br />
                        Avenida Presidente Masaryk 275, 11560, Col. Polanco, CDMX.
                        </TextAca>
                     </CardWhiteCoach>
                  </CardCoach>
               </ContentContainer>
            </Content>
         </ViewAcademy>
      );
      
   }

   return (
      <ViewAcademy>
         <Content>
            <ContentContainer>
               <CardCoach width="100%" className="full">
                  <img src={require("../../../assets/image/views/map_domecq.png")} alt="experience" className="profileImg" />
                  <CardWhiteCoach className="hasIcon contact">
                     <img src={require("../../../assets/icons/location.png")} alt="experience" className="iconDot" width="100%" />
                     <ThinTitle color={Color.primary}>NUESTRA UBICACIÓN</ThinTitle>
                     <TextAca>
                     Domecq Academy se encuentra ubicado dentro del Corporativo Casa Pedro Domecq, en el corazón
                        de Polanco.<br /> <br />
                     Avenida Presidente Masaryk 275, 11560, Col. Polanco, CDMX.
                     </TextAca>
                  </CardWhiteCoach>
               </CardCoach>
            </ContentContainer>
         </Content>
      </ViewAcademy>
   );
}

/*
export default function MapAcademy() { 
   return (
      <ViewAcademy> 
         <Content>
            <MapContact width="100%" />
            <CardMapAcademy className="hasIcon">
               <img src={require("../../../assets/icons/location.png")} alt="experience" className="iconCard" width="100%" />
               <ThinTitle color={Color.primary}>NUESTRA UBICACIÓN</ThinTitle>
               <TextAca>
                  Domecq Academy se encuentra ubicado dentro del Coporativo Casa Pedro Domecq en el corazón de Polanco. <br /> <br />
                  Avenida Presidente Masaryk 275. Colonia Polanco. 11550. CDMX (Entrada por Temístocles)
               </TextAca>
            </CardMapAcademy>
         </Content>
      </ViewAcademy>
   );
}
 */
